import type { Directive } from 'vue'

/**
 * `v-no-backdrop-close` —— 大弹窗遮罩：挡掉「真实点击遮罩」关闭(防误触丢填写内容),
 * 但**不影响 Esc**。
 *
 * 背景:本项目遮罩统一 `@click.self="<close>"`,且 [`useModalEscape`] 的 Esc 是靠
 * **合成一次点击遮罩**(`el.click()`,isTrusted=false)来复用各弹窗自己的关闭逻辑。
 * 所以不能简单删 `@click.self`(会连 Esc 一起废)。
 *
 * 本指令在**捕获阶段**(早于 bubble 的 @click.self)拦截:只有「点击点就是遮罩本身
 * 且是真实用户点击(isTrusted)」时 `stopImmediatePropagation`,阻止同元素上的
 * @click.self 触发 → 真实点遮罩不再关。Esc 的合成 click(isTrusted=false)不拦,
 * 照常走 @click.self 关闭。点弹窗内容(target≠遮罩)本就不触发 @click.self,不受影响。
 *
 * 用法:给大弹窗的遮罩元素加 `v-no-backdrop-close`(保留其 `@click.self`)。小的
 * 确认/提示/结果框不加 —— 点遮罩取消是常规且无害。
 */
function onCaptureClick(e: MouseEvent) {
  if (e.target === e.currentTarget && e.isTrusted) {
    e.stopImmediatePropagation()
  }
}

export const vNoBackdropClose: Directive<HTMLElement> = {
  mounted(el) {
    el.addEventListener('click', onCaptureClick, true)
  },
  unmounted(el) {
    el.removeEventListener('click', onCaptureClick, true)
  }
}
